import { closingColon } from "./helpers.js";
import { StyleOperations } from "./styles.js";

export const DivOperations = {
  isTrue: (arg) => {
    // check if it's a div
    let matcher = /\bbox\b/g;
    return matcher.test(arg);
  },
  /**
   * When you detect an opening colon, use a stack to find it's closing semi colon
   * box:
   */
  hasOpened: true,

  // closingColon: (readLines, index) => {
  //   // detect the closing colon and convert it to div
  //   let stack = [];
  //   let openingColon = /:/;
  //   let closingColon = /;/;
  //   console.log(readLines);

  //   for (let i = index; i < readLines.length; i++) {
  //     let x = readLines[i];
  //     if (DivOperations.isDiv(x)) {
  //       DivOperations.hasOpened = true;
  //     }

  //     if (openingColon.test(x) && DivOperations.hasOpened) {
  //       stack.push(":");
  //     } else if (closingColon.test(x)) {
  //       stack.pop();
  //     }
  //     console.log(stack);
  //     if (!stack.length) {
  //       // console.log(`closing for ${index + 1} is ${i + 1}`); // cliosing tags for specif
  //       readLines[i] = "</div>";
  //       DivOperations.hasOpened = false;
  //       return;
  //     }
  //   }
  // },

  // FIXME: should account for the classname and the inline styles

  openingColon: (arg) => {
    // will have a name and inline styles
    // if(StyleOperations.isStyle(arg)){ //TODO: there ia a className
      arg = arg.replace(/\bbox\b/, "<div ").replace(":", "");
    // }else{
    //   arg = arg.replace(/\bbox\b/, "<div>").replace(":", "");

    // }
    return arg;
  },
};

export const runDivOperations = (readLinesOriginal, readLines, errors) => {
  for (var i = 0; i < readLines.length; i++) {
    let x = readLines[i];
    // console.log(x)
    if (DivOperations.isTrue(x)) {
      // DivOperations.closingColon(readLines, i);
      closingColon(readLines,i,DivOperations,'</div>')
      readLines[i] = DivOperations.openingColon(x);
      // console.log(x)
      // console.log(readLines);
    } else {

    }
    // console.log("panashe")
  }
  return readLines;
};
